__turbopack_context__.v({
  "claim-offer": "ClaimOfferForm-module-scss-module__wj2vfG__claim-offer",
  "claim-offer__card": "ClaimOfferForm-module-scss-module__wj2vfG__claim-offer__card",
  "claim-offer__consent": "ClaimOfferForm-module-scss-module__wj2vfG__claim-offer__consent",
  "claim-offer__copy": "ClaimOfferForm-module-scss-module__wj2vfG__claim-offer__copy",
  "claim-offer__cta": "ClaimOfferForm-module-scss-module__wj2vfG__claim-offer__cta",
  "claim-offer__email": "ClaimOfferForm-module-scss-module__wj2vfG__claim-offer__email",
  "claim-offer__email-helper": "ClaimOfferForm-module-scss-module__wj2vfG__claim-offer__email-helper",
  "claim-offer__email-label": "ClaimOfferForm-module-scss-module__wj2vfG__claim-offer__email-label",
  "claim-offer__email-value": "ClaimOfferForm-module-scss-module__wj2vfG__claim-offer__email-value",
  "claim-offer__error": "ClaimOfferForm-module-scss-module__wj2vfG__claim-offer__error",
  "claim-offer__eyebrow": "ClaimOfferForm-module-scss-module__wj2vfG__claim-offer__eyebrow",
  "claim-offer__form": "ClaimOfferForm-module-scss-module__wj2vfG__claim-offer__form",
  "claim-offer__heading": "ClaimOfferForm-module-scss-module__wj2vfG__claim-offer__heading",
  "claim-offer__inbox": "ClaimOfferForm-module-scss-module__wj2vfG__claim-offer__inbox",
  "claim-offer__layout": "ClaimOfferForm-module-scss-module__wj2vfG__claim-offer__layout",
  "claim-offer__media": "ClaimOfferForm-module-scss-module__wj2vfG__claim-offer__media",
  "claim-offer__row": "ClaimOfferForm-module-scss-module__wj2vfG__claim-offer__row",
});
